export const WHEEL_CATEGORY_SLUGS = [
  'wheels',
  'alloyWheels',
  'steelWheels',
  'spareWheels',
  'otheWheels',
  'otherWheels',
];
